export const environment = {
    production: false,
    environmentName: 'qa',

    backend:{
        url: 'https://conta-qa.transtecniasa.cl',
        port: '',
        api_version: 'api-confinanzas'
    },


    useBackend: true,
    isApiReady: false,

    getURL: function(url): string{
        return this.getBackendUrl(url)
    },

    getBackendUrl: function(url): string{
        return this.backend.url
        + (this.backend.port !== '' ? (':' + this.backend.port) : '')
        + '/' + this.backend.api_version + '/' + url;
    }
};